export default "__VITE_ASSET__BxHAqpgH__"